<script setup>
import { computed } from 'vue';

import { playgroundContent } from '../../helpers/kraftchatAIPlaygroundConfig';

const props = defineProps({
  result: {
    type: Object,
    required: true,
  },
});

const providerLabel = computed(() => {
  if (!props.result?.provider) return '';

  return `${props.result.provider.provider} · ${props.result.provider.model}`;
});
</script>

<template>
  <div class="space-y-4">
    <div class="space-y-1">
      <div class="flex flex-wrap items-center gap-2">
        <h3 class="text-lg font-semibold text-n-slate-12">
          {{ playgroundContent.resultTitle }}
        </h3>

        <span
          v-if="providerLabel"
          class="rounded-md bg-n-alpha-2 px-2 py-0.5 text-xs font-medium text-n-slate-11"
        >
          {{ providerLabel }}
        </span>
      </div>

      <p class="text-sm leading-6 text-n-slate-11">
        {{ playgroundContent.resultDescription }}
      </p>
    </div>

    <div class="rounded-xl border border-n-brand/20 bg-n-brand/10 p-4">
      <p class="whitespace-pre-line text-sm leading-7 text-n-slate-12">
        {{ result.answer }}
      </p>
    </div>
  </div>
</template>
